import { AxiosInstance } from "axios"
import { MeetingServiceOrder, Merchant, ReportDetails } from "./meetingServiceTypes"

type MerchantsForOfficeManagerParams = Readonly<{
    companyId: number
    userGroupId: number
}>

export type MerchantsForOfficeManagerResponse = Readonly<{
    merchants: Merchant[]
}>

export async function fetchMerchantsForOfficeManager(
    { companyId, userGroupId }: MerchantsForOfficeManagerParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MerchantsForOfficeManagerResponse> {
    const url = `/companies/${companyId}/userGroups/${userGroupId}/merchants`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type MeetingServiceOrdersForOfficeManagerParams = Readonly<{
    companyId: number
    userGroupId: number
    startDate: string
    endDate: string
    merchantId: string
}>

export type MeetingServiceOrdersForOfficeManagerResponse = Readonly<{
    reportDetails: ReportDetails
    orders: MeetingServiceOrder[]
}>

export async function fetchMeetingServiceOrdersForOfficeManager(
    params: MeetingServiceOrdersForOfficeManagerParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServiceOrdersForOfficeManagerResponse> {
    const { companyId, userGroupId, startDate, endDate, merchantId } = params
    const url = `/companies/${companyId}/userGroups/${userGroupId}/accounting/meetingService/orders`

    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
            merchantId,
        },
        signal,
    })

    return data
}
